import {
  Text,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import * as React from "react";

const useStyles = makeStyles({
  text: {
    color: tokens.colorNeutralForeground1,
    display: "flex",
    flexDirection: "column",
    fontStyle: "normal",
    ...shorthands.gap("10px"),
    ...shorthands.padding("0px", "5%", "20px", "5%"),
  },

  title: {
    fontSize: "28px",
    textOverflow: "ellipsis",
    lineHeight: "normal",
    fontStyle: "normal",
    fontWeight: "400",
    ...shorthands.overflow("hidden"),
    "@media (max-width: 960px)": {
      lineHeight: "22px",
      fontWeight: "600",
      fontSize: "16px",
    },
  },

  readNow: {
    fontFamily: "Segoe UI",
    lineHeight: "22px",
    fontWeight: "600",
    fontSize: "16px",
    fontStyle: "normal",
    color: tokens.colorBrandForeground1,
    textAlign: "start",
    "@media (max-width: 960px)": {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
});

export const PromptArtItemFooter: React.FC<{
  title: string;
  ctaText: string;
}> = ({ title, ctaText }) => {
  const styles = useStyles();
  return (
    <div className={styles.text}>
      <div>
        <Text className={styles.title}>{title}</Text>
      </div>
      <div>
        <span className={styles.readNow}>{ctaText}</span>
      </div>
    </div>
  );
};
